import type { EditorState } from "@codemirror/state";
import { StateField, type Extension } from "@codemirror/state";
import { Decoration, EditorView, type DecorationSet } from "@codemirror/view";
import { getLanguageSupport, languageIdForPath } from "../../codeLanguages";

function frontmatterDecorations(state: EditorState): DecorationSet {
  const { doc } = state;
  if (doc.line(1).text !== "---") return Decoration.none;
  for (let lineNumber = 2; lineNumber <= doc.lines; lineNumber++) {
    const line = doc.line(lineNumber);
    if (line.text !== "---") continue;
    return Decoration.set([
      Decoration.mark({ class: "cm-frontmatter" }).range(0, line.to),
    ]);
  }
  return Decoration.none;
}

const frontmatterField = StateField.define<DecorationSet>({
  create: frontmatterDecorations,
  update: (decorations, transaction) =>
    transaction.docChanged
      ? frontmatterDecorations(transaction.state)
      : decorations,
  provide: (field) => EditorView.decorations.from(field),
});

const frontmatterTheme = EditorView.baseTheme({
  ".cm-frontmatter": {
    color: "var(--text-secondary) !important",
  },
  ".cm-frontmatter *": {
    color: "var(--text-secondary) !important",
  },
});

export function getLanguageExtension(filePath: string): Extension | null {
  const id = languageIdForPath(filePath);
  if (!id) return null;
  const support = getLanguageSupport(id);
  if (id === "markdown") return [support, frontmatterField, frontmatterTheme];
  return support;
}
